import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function PDFIcon({ className, fill, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      height={height ?? 24}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <g fill={fill ?? IconColors.Red} fillRule="evenodd">
        <path d="M5.9 8.5v6.968c0 .415.336.75.75.75s.75-.335.75-.75v-2.037c1.544-.029 2.787-1.29 2.787-2.84 0-1.57-1.271-2.841-2.84-2.841H6.65c-.414 0-.75.336-.75.75zm1.5.751c.716.028 1.287.617 1.287 1.34 0 .722-.571 1.311-1.287 1.339V9.251zm10.22 2.399V9.894c0-.356.289-.644.644-.644h1.394c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.394c-1.184 0-2.144.96-2.144 2.144v5.574c0 .415.336.75.75.75.415 0 .75-.335.75-.75V13.15h1.34c.415 0 .75-.336.75-.75 0-.415-.335-.75-.75-.75h-1.34zm5.005 9.287c0 .76-.616 1.375-1.375 1.375H4.75c-.76 0-1.375-.615-1.375-1.375V3.063c0-.759.616-1.374 1.375-1.374h13.791c.36 0 .704.14.96.39l2.709 2.643c.265.259.415.614.415.984v15.233zM11.76 16.218c1.954 0 3.538-1.583 3.538-3.537v-1.394c0-1.953-1.584-3.537-3.538-3.537-.414 0-.75.336-.75.75v6.968c0 .415.336.75.75.75zm2.038-3.537c0 .86-.534 1.596-1.288 1.895V9.392c.754.3 1.288 1.035 1.288 1.895v1.394z" />
      </g>
    </SimpleIcon>
  );
}
